
import { Component, Vue } from "vue-property-decorator";
import { Bar } from 'vue-chartjs/legacy';
import { dataVisualizationModule } from "@/store";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

@Component({
  components: {
    Bar
  }
})
export default class PatientChart extends Vue {
  chartDatas = {
    labels: [] as string[],
    datasets: [
      {
        label: "",
        backgroundColor:  ['#ffac1c',
          '#ff6f00',
          '#ffd700',
          '#ff8c00',
          '#ffa07a',
          '#ffc107'],
        data: [] as number[],
      }
    ]
  };

  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      }
    },
    scales: {
      y: {
        ticks: {
          precision: 0, // no decimals
          stepSize: 1,  // force step size of 1
          callback: function (value: number) {
            return Number.isInteger(value) ? value : '';
          }
        },
        beginAtZero: true
      }
    }
  };

  get rawChartData(): any[] {
    return dataVisualizationModule.getChartData("centerInfo");
  }

  get chartDataAvailable(): boolean {
    return this.chartDatas.labels.length > 0 && this.chartDatas.datasets[0].data.length > 0;
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("centerInfo");

      const rawData = this.rawChartData[0]; // since query returns a single row

      if (!rawData) {
        console.warn("No chart data received.");
        return;
      }

      const labels = [

        "Patienten in Universitäten",
        "Patienten in Kliniken",
        "Patienten in Praxen"
      ];

      const data = [
        rawData.UniversityPatientCount,
        rawData.ClinicalPatientCount,
        rawData.PracticePatientCount
      ];

      this.chartDatas = {
        labels,
        datasets: [
          {
            label: "Zentren Übersicht",
            backgroundColor: [
              '#ffac1c',
              '#ff6f00',
              '#ffd700',
              '#ff8c00',
              '#ffa07a'
            ],
            data
          }
        ]
      };
    } catch (e) {
      console.error("Failed to load chart data", e);
    }
  }
}
